<template>
  <div
    class="modal form-modal fade"
    :id="name + 'Modal'"
    tabindex="-1"
    :aria-labelledby="name + 'Label'"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content mx-auto position-relative">
        <div :class="is_alert != true ? 'bg-custom-gradient border-bottom border-1 py-5' : 'border-0'" class="modal-header  position-relative">
          <button
            type="button"
            :class="close_btn_color == 'white' ? 'white' : '' " class="btn-close position-absolute end-0 top-0 m-3"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
          <div
            v-if="is_alert != true"
            :class="form_img == true ? 'img_form' : ''"
            class="
              modal-icon
              bg-light
              d-flex
              align-items-center
              justify-content-center
              position-absolute
              start-50
              mt-5
              translate-middle
            "
          >
            <img :src="modal_img" alt="" />
            <label v-if="form_img" for="team_avatar" class="position-absolute bottom-0 mb-2 text-white" role="button">Upload</label>
            <input v-if="form_img" type="file" id="team_avatar" class="d-none">
          </div>

        </div>
        <div class="modal-body p-4">
          <div class="text-center" v-if="is_alert">
            <img v-if="alert_img" :src="alert_img" width="140" alt="" />
          </div>
          <h3 v-if="modal_title" class="fw-bold mt-5 mb-3 text-center fs-4">
            {{ modal_title }}
          </h3>
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["name", "modal_title", "modal_img","form_img","is_alert","alert_img","close_btn_color"]
};
</script>